import { useCallback } from "react";
import ModalBasicLayout from "./ModalBasicLayout";
import TemplateEditor from "../../pages/Templates/TemplateEditor";
import { useTemplatesModals } from "../../contexts/templatesModalsContext";
import { useTranslationApp } from "../../lib/i18next";
import { TEMPLATES_TITLE } from "../../i18n/keysTranslations";

const ModalTemplateEditor = ({
  modalOpen,
  onCloseModal,
  templateID = "",
}) => {
  const { t } = useTranslationApp();
  const { openTemplatesList } = useTemplatesModals();

  const onBackToList = useCallback(() => {
    onCloseModal();
    openTemplatesList();
  }, [onCloseModal, openTemplatesList]);

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullScreen={true}
      maxWidth={false}
      fullWidth={true}
      hasTitle={false}
      ariaLabel={t(TEMPLATES_TITLE)}
      sxContent={{
        py: 0,
        px: 0,
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        maxHeight: "100vh",
        overflow: "hidden",
      }}
      sxPaper={{
        height: "100vh",
        maxHeight: "100vh",
      }}
    >
      <TemplateEditor templateID={templateID} onBackToList={onBackToList} />
    </ModalBasicLayout>
  );
};

export default ModalTemplateEditor;
